"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsValidContatos = void 0;
const class_validator_1 = require("class-validator");
const email_1 = require("../email");
const phone_1 = require("../phone");
let IsValidContatos = class IsValidContatos {
    validate(contatos) {
        const invalidContatos = contatos.some(contato => {
            if (contato.tipo === 'email')
                return !(0, email_1.isValidMask)(contato.valor);
            if (contato.tipo === 'telefone')
                return !(0, phone_1.isValidMask)(contato.valor);
            return false;
        });
        const emailsPrincipais = contatos.filter(contato => {
            return contato.tipo === 'email' && contato.categoria === 'principal';
        });
        return !invalidContatos && emailsPrincipais.length === 1;
    }
    defaultMessage() {
        return '$property should be valid';
    }
};
IsValidContatos = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ async: true })
], IsValidContatos);
exports.IsValidContatos = IsValidContatos;
//# sourceMappingURL=is-valid-contatos.js.map